/**
 * Centralized visibility lists for page elements (menu, top bar).
 */
import Pages from '@pages';

// ------------------------------------------------------------
// Page blacklists
// ------------------------------------------------------------

/** Page keys where the dial is hidden. */
export const DIAL_PAGES_BLACKLIST = [
  Pages.LANGUAGES,
  Pages.LINK,
  Pages.SUCCESSFUL_LINK,
  Pages.WELCOME,
] as const;

/** Page keys where the main menu is hidden. */
export const MENU_PAGES_BLACKLIST = [
  Pages.DETAIL_ADDON,
  Pages.LANGUAGES,
  Pages.LINK,
  Pages.PLAYER,
  Pages.SUCCESSFUL_LINK,
  Pages.WELCOME,
  Pages.ZAPPER,
] as const;

/** Page keys where the top bar is hidden. */
export const TOP_BAR_PAGES_BLACKLIST = [
  Pages.DETAIL,
  Pages.DETAIL_ADDON,
  Pages.LANGUAGES,
  Pages.LINK,
  Pages.PLAYER,
  Pages.SEARCH,
  Pages.SUCCESSFUL_LINK,
  Pages.WELCOME,
  Pages.ZAPPER,
] as const;
